
export default {
  name: 'ClinicSummary',

  props: {
    clinic: {
      type: Object,
      required: true,
    },
    single: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    toClinic() {
      this.$router.push(
        this.localePath({
          name: 'clinic-slug',
          params: { slug: this.clinic.slug },
        })
      );
    },
  },
};
